/**
 * NotificationToasts — global toast renderer for uiStore notifications.
 *
 * Extracted from EditorPage (2026-07-23) so pages other than the editor can
 * surface notifications. Before this, addNotification() calls made on
 * /dashboard (project-open failures, "Location set", "Default view saved")
 * pushed into the store but nothing rendered them until the user navigated
 * into the editor. Mount once per page that needs toasts.
 */

import { useUIStore } from '../../stores/uiStore';
import './NotificationToasts.css';

export default function NotificationToasts() {
  const notifications = useUIStore((s) => s.notifications);
  const removeNotification = useUIStore((s) => s.removeNotification);

  if (notifications.length === 0) return null;

  return (
    <div className="toast-container">
      {notifications.map((n) => (
        <div key={n.id} className={`toast toast--${n.type}`}>
          <div className="toast__content">
            <strong className="toast__title">{n.title}</strong>
            {n.message && <span className="toast__message">{n.message}</span>}
          </div>
          {n.action && (
            <button
              className="toast__action"
              type="button"
              onClick={() => {
                n.action!.onClick();
                removeNotification(n.id);
              }}
            >
              {n.action.label}
            </button>
          )}
          <button className="toast__close" onClick={() => removeNotification(n.id)} type="button">&times;</button>
        </div>
      ))}
    </div>
  );
}
